import { NgModule }      from '@angular/core';
import {CommonModule} from '@angular/common';

import { VariablesHelpComponent }  from './variablesHelp.component';
import { BrowserClipboardModule } from '../../service/browserClipboard/browserClipboard.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        BrowserClipboardModule,
        FontAwesomeModule
    ],
  declarations: [
    VariablesHelpComponent,
  ],
  exports: [
    VariablesHelpComponent,
  ]
})
export class VariablesHelpModule {  }